/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Mtmsa_TitleInputs */



/**
* | output |
* | --- |
* | "MTMSA" |
*
* @param {Service_Mtmsa_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_mtmsa_title = /** @type {((inputs?: Service_Mtmsa_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Mtmsa_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("MTMSA")
	return /** @type {LocalizedString} */ ("MTMSA")
});